<template>
  <NavBar></NavBar>
  <HeroSection></HeroSection>
  <DoDont></DoDont>
  <InstaGram></InstaGram>
  <DownloadableAssets></DownloadableAssets>
  <FooterBar></FooterBar>

  <pie-cookie-banner
    id="es-cookie-banner"
    v-if="isES"
    :locale="esES"
    cookieStatementLink="https://www.just-eat.es/info/cookies-policy"
    cookieTechnologiesLink="https://www.just-eat.es/info/technology-list"
    hasPrimaryActionsOnly="true"
  ></pie-cookie-banner>
  <beCookieBanner v-if="isBE"></beCookieBanner>
  <bgCookieBanner v-if="isBG"></bgCookieBanner>
  <pie-cookie-banner
    id="dk-cookie-banner"
    v-if="isDK"
    :locale="dkDK"
    cookieStatementLink="https://www.just-eat.es/info/cookies-policy"
    cookieTechnologiesLink="https://www.just-eat.es/info/technology-list"
    hasPrimaryActionsOnly="true"
  ></pie-cookie-banner>
  <nlCookieBanner v-if="isNL"></nlCookieBanner>
  <chCookieBanner v-if="isCH"></chCookieBanner>
  <frCookieBanner v-if="isFR"></frCookieBanner>
  <atCookieBanner v-if="isAT"></atCookieBanner>
  <deCookieBanner v-if="isDE"></deCookieBanner>
  <plCookieBanner v-if="isPL"></plCookieBanner>
</template>

<script>
import "@justeattakeaway/pie-css";
import NavBar from "./components/NavBar.vue";
import FooterBar from "./components/FooterBar.vue";
import HeroSection from "./components/HeroSection.vue";
import DoDont from "./components/DoDont.vue";
import InstaGram from "./components/InstaGram.vue";
import { register } from "swiper/element/bundle";
import DownloadableAssets from "./components/DownloadableAssets.vue";
import "@justeattakeaway/pie-cookie-banner";
import esES from "@justeattakeaway/pie-cookie-banner/locales/es-es.json";
import beCookieBanner from "./components/cookieBanners/beCookieBanner.vue";
import bgCookieBanner from "./components/cookieBanners/bgCookieBanner.vue";
import nlCookieBanner from "./components/cookieBanners/nlCookieBanner.vue";
import dkDK from "@justeattakeaway/pie-cookie-banner/locales/dk-dk.json";
import chCookieBanner from "./components/cookieBanners/chCookieBanner.vue";
import frCookieBanner from "./components/cookieBanners/frCookieBanner.vue";
import atCookieBanner from "./components/cookieBanners/atCookieBanner.vue";
import deCookieBanner from "./components/cookieBanners/deCookieBanner.vue";
import plCookieBanner from "./components/cookieBanners/plCookieBanner.vue";

let lang = process.env.VUE_APP_LOCALITY;

register();

export default {
  mounted() {
    if (lang == "es_es") {
      window.addEventListener("load", () =>
        this.CookieValue("es-cookie-banner")
      );
    }
    if (lang == "dk_dk") {
      window.addEventListener("load", () =>
        this.CookieValue("dk-cookie-banner")
      );
    }
  },
  name: "App",
  components: {
    NavBar,
    FooterBar,
    HeroSection,
    DoDont,
    InstaGram,
    DownloadableAssets,
    beCookieBanner,
    bgCookieBanner,
    nlCookieBanner,
    chCookieBanner,
    frCookieBanner,
    atCookieBanner,
    deCookieBanner,
    plCookieBanner,
  },
  data: function () {
    return {
      esES,
      dkDK,
      isES: lang == "es_es" ? true : false,
      isBG: lang == "bg_bg" ? true : false,
      isBE: lang == "be_fr" || lang == "be_nl" ? true : false,
      isDK: lang == "dk_dk" ? true : false,
      isNL: lang == "nl_nl" ? true : false,
      isCH: lang == "ch_fr" || lang == "ch_de" ? true : false,
      isFR: lang == "fr_fr" ? true : false,
      isAT: lang == "at_de" ? true : false,
      isDE: lang == "de_de" ? true : false,
      isPL: lang == "pl_pl" ? true : false,
    };
  },
  methods: {
    CookieValue(bannerID) {
      let cookieBanner = document.getElementById(bannerID);
      let cookie;
      let name = "customerCookieConsent=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");

      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          cookie = c.substring(name.length, c.length);
        }
      }

      if (cookie == undefined) {
        cookieBanner.classList.add("display");
        let acceptAll = cookieBanner.shadowRoot.querySelector(
          '[data-test-id="actions-accept-all"]'
        );
        let necessaryOnly = cookieBanner.shadowRoot.querySelector(
          '[data-test-id="actions-necessary-only"]'
        );
        let allCookies = cookieBanner.shadowRoot.getElementById("all");
        let functionalCookies =
          cookieBanner.shadowRoot.getElementById("functional");
        let analyticalCookies =
          cookieBanner.shadowRoot.getElementById("analytical");
        let personalizedCookies =
          cookieBanner.shadowRoot.getElementById("personalized");
        let saveButton = cookieBanner.shadowRoot
          .querySelectorAll("pie-modal")[0]
          .shadowRoot.querySelector('[data-test-id="modal-leading-action"]');

        acceptAll.addEventListener("click", function () {
          document.cookie = "customerCookieConsent=full";
        });
        necessaryOnly.addEventListener("click", function () {
          document.cookie = "customerCookieConsent=necessary";
        });
        saveButton.addEventListener("click", function () {
          if (allCookies.checked == 1) {
            document.cookie = "customerCookieConsent=full";
          } else {
            let fun = "";
            let anal = "";
            let pers = "";
            let count = 0;

            if (functionalCookies.checked == 1) {
              fun = "essential";
              count++;
            }

            if (analyticalCookies.checked == 1) {
              if (count > 0) {
                anal = "%20analytics";
              } else {
                anal = "analytics";
              }
              count++;
            }

            if (personalizedCookies.checked == 1) {
              if (count > 0) {
                pers = "%20personalized";
              } else {
                pers = "personalized";
              }
            }

            let val = fun + anal + pers;

            document.cookie = "customerCookieConsent=" + val;
          }
        });
      }
    },
  },
};
</script>

<style>
@font-face {
  font-family: "JETSansDigital";
  src: url("assets/fonts/JETSansDigital-Regular.woff2") format("woff2"),
    url("assets/fonts/JETSansDigital-Regular.woff") format("woff");
  font-display: swap;
}

@font-face {
  font-family: "JETSansDigital-Bold";
  src: url("assets/fonts/JETSansDigital-Bold.woff2") format("woff2"),
    url("assets/fonts/JETSansDigital-Bold.woff") format("woff");
  font-display: swap;
}

.mozzarella {
  background: #efedea;
}

.white {
  background: #ffffff;
}

.offWhite {
  background: #fcfcfc;
}

h1 {
  color: #242e30;
  font-family: "JETSansDigital-Bold", sans-serif;
  font-size: 46px;
  font-style: normal;
  font-weight: 800;
  line-height: 48px;
  margin: 0 auto 35px;
}

h2 {
  color: #242e30;
  font-family: "JETSansDigital-Bold", sans-serif;
  font-size: 36px;
  font-style: normal;
  font-weight: 800;
  line-height: 43.2px;
  margin: 0;
}

body {
  margin: 0;
  padding: 0;
}

.custom-button {
  z-index: 10;
  cursor: pointer;
  position: relative;
  display: block;
  overflow: hidden;
  max-width: 260px;
  width: 100%;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 30px;
  margin: 0 auto;
  font-family: "JETSansDigital", sans-serif;
  font-weight: bold;

  padding: 16px 30px 14px;
  text-align: center;
  color: #fff;
  border: 0;

  -webkit-transition: all 0.2s ease-In-Out;
  transition: all 0.2s ease-In-Out;
}

.custom-button--orange {
  background: #ff8000;
  color: white;
  max-width: 391px;
  font-size: 16px;
  line-height: 20px;
  margin: 0px auto 0 0;
}

.custom-button--orange:hover {
  background: #e75900;
}

.custom-button--white {
  background: #ffffff;
  color: #242e30;
  max-width: 234px;
  font-size: 16px;
  line-height: 20px;
  margin: 0px auto 0 0;
  border: 2px solid #242e30;
}

.custom-button--white:hover {
  background: #efedea;
}

.swiper-button-prev,
.swiper-button-next,
.sticker-button-next,
.sticker-button-prev {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-image: url("./assets/icons/chevron.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 36px;
  border: none;
  background-color: transparent;
  width: 36px;
  cursor: pointer;
}

.sticker-button-next,
.sticker-button-prev {
  top: 30%;
}


.swiper-button-next,
.sticker-button-next {
  transform: translateY(-50%) rotate(180deg) !important;
  right: 0;
}

.swiper-button-prev,
.sticker-button-prev {
  left: 0;
}

.swiper-button-prev span,
.swiper-button-next span,
.sticker-button-prev span,
.sticker-button-next span {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  visibility: hidden;
}

.swiper-button-lock {
  display: none;
}

@media only screen and (max-width: 768px) {
  h1 {
    font-size: 45px;
  }

  h2 {
    font-size: 30px;
  }

  .swiper-button-next,
  .sticker-button-next{
    right: 35px;
  }

  .swiper-button-prev,
  .sticker-button-prev {
    left: 35px;
  }
}

#es-cookie-banner,
#bg-cookie-banner {
  display: none;
}

#es-cookie-banner.display,
#bg-cookie-banner.display {
  display: block;
}
</style>
